module.exports = __webpack_public_path__ + "img/stock7.f8beb251.png";